import { Injectable } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { AgreementAcceptComponent } from './agreement-accept.component';
import { Observable, of} from 'rxjs';
import { take, switchMap } from 'rxjs/operators';
import { CheckParentModalService } from '../check-parent/check-parent.service';

@Injectable()

export class AgreementAcceptModalService {
  constructor(
    private modal: BsModalService,
    private checkParent:CheckParentModalService,
  ) { 
  }
  open():Observable<boolean> {
    const modal:BsModalRef = this.modal.show(AgreementAcceptComponent, {class:'modal-lg'}); 
    return modal.content.action.pipe(
      take(1),
      switchMap((data?:{ofAge:boolean})=>{
        if (!data) return of(false);
        else if (data.ofAge) return of(true);
        else return this.checkParent.open(); 
      })
    )
  }
}
